export const SHARED_PHYSICS_RIPPLE_SELECTORS = [
  '.ui-button.--variant-primary',
  '.ui-button.--variant-secondary',
  '.ui-button.--variant-glass',
  '.ui-button.--variant-nav',
  '.ui-button.--variant-scrim',
  '.ui-navigation__page',
  '.ui-chip',
  '.ui-watch-card-base__genre',
  '.ui-tabs-switch__tab',
  '.app-bottom-navigation__indicator',
  '.ui-aside-genres__chip',
  '.ui-watch-card-base',
]

export const SHARED_PHYSICS_TILT_SELECTORS = [
  '.ui-plan-card',
  '.plan-detail__card',
  '.about-team__card',
  '.watch-detail.--poster-hover-tilt .ui-watch-card-base__header',
]

export const SHARED_PHYSICS_MAGNET_SELECTORS = [
  '.ui-navigation__page',
  '.ui-header-actions .ui-button.--icon',
  '.ui-header-actions .entity-user-activator',
  '.ui-burger',
  '.ui-carousel-arrows__button:not(:disabled)',
  '.app-footer-social__link',
  '.ui-watch-player-guest-banner__play',
]

export const SHARED_PHYSICS_MAGNET_RADIUS_PX = 56

export const SHARED_PHYSICS_MAGNET_PULL = 0.35

export const SHARED_PHYSICS_MAGNET_MAX_PX = 6

export const SHARED_PHYSICS_TILT_MAX_DEG = 5

export const SHARED_PHYSICS_RIPPLE_DURATION_MS = 620
